// V1
import "./ProfilePostsSummary.css";
import { useQuery } from "@apollo/client";
import { PROFILE_POSTS } from "../../../api/profile";
import Post from "../../Post";
import Button from "../../Button";
import { useHistory, useLocation } from "react-router-dom";
import captureException from "../../../utils/captureException";

function ProfilePostsSummary({ id }) {
  const history = useHistory();
  const location = useLocation();
  const { error, data } = useQuery(PROFILE_POSTS, {
    variables: { id, take: 3 },
  });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "ProfilePostsSummary",
        query: "PROFILE_POSTS",
      },
    });
    console.log(error);
    return <div>error</div>;
  }

  const org = data?.profile;
  const posts = org?.posts;

  //   console.log(posts);
  return (
    <div className="profile-overview-posts">
      {posts?.slice(0, 3).map((post) => (
        <Post key={"profile-posts-summary-" + post.id} post={post} />
      ))}

      {!!posts?.length && (
        <div className="show-more-container">
          <Button
            className="primary small blue show-more-button"
            onClick={() => {
              history.replace(location.pathname + "?t=posts");
            }}
          >
            See all posts
          </Button>
        </div>
      )}
    </div>
  );
}

export default ProfilePostsSummary;
